import { render, staticRenderFns } from "./Pegman.vue?vue&type=template&id=7603f359&"
import script from "./Pegman.vue?vue&type=script&lang=ts&"
export * from "./Pegman.vue?vue&type=script&lang=ts&"
import style0 from "./Pegman.vue?vue&type=style&index=0&id=7603f359&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports